import { intersection } from 'ramda';

import { IJsonQuery, ERoomType } from '../json_query';
import { dealTypeFromJsonQuery, offerTypeFromJsonQuery, isUrban, FDealType } from './category';

export function isWithLayoutAvailable(jsonQuery: IJsonQuery): boolean {
  const dealType = dealTypeFromJsonQuery(jsonQuery);

  if ((dealType & FDealType.Rent) !== 0) {
    return false;
  }

  return true;
}

export function isRoomTypeAvailable(jsonQuery: IJsonQuery): boolean {
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  if (!isUrban(offerType)) {
    return false;
  } else if (
    jsonQuery.room &&
    jsonQuery.room.value &&
    intersection([ERoomType.Studio, ERoomType.FlatOneRoom, ERoomType.FlatFreeLayout], jsonQuery.room.value).length ===
      jsonQuery.room.value.length
  ) {
    return false;
  }

  return true;
}
